import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GBMConversationItemModel,
  GBMConversationListModel,
  GBMMessageItemModel,
  GBMMessageListModel,
} from '../models/GBMessage.model';
import { LeadModel, LeadsModel } from '../models/Lead.model';
import { NotificationModel } from '../models/Notification.model';
import { ReviewModel, ReviewsModel } from '../models/Review.model';
import { IReviewLink } from '../models/Reviews-api.properties';

export interface IMessagesService {
  // LEADS
  getLeads(): Observable<LeadsModel>;
  setLeadAsRead(id: number): Observable<LeadModel>;

  //REVIEWS
  getReviews(): Observable<ReviewsModel>;
  getReview(reviewId: string): Observable<ReviewModel>;
  upsertReply(review: ReviewModel, comment: string): Observable<ReviewModel>;
  deleteReply(reviewId: string): Observable<boolean>;
  getReviewLink(): Observable<string>;

  //GOOGLE MESSAGES
  getNotifications(): Observable<any>;
  setNotificationAsRead(id: number): Observable<any>;
  deleteNotification(id: number): Promise<any>;

  //GBM
  getGBMConversationList(): Observable<GBMConversationItemModel[]>;
  getGBMMessageList(
    conversationId: string | number
  ): Observable<GBMMessageListModel>;
  replyGBMMessage(
    conversationId: string | number,
    message: string
  ): Observable<GBMMessageItemModel>;
}

export const MESSAGES_SERVICE = new InjectionToken<IMessagesService>(
  'messagesService'
);
